export default __webpack_public_path__ + "static/media/partners_logos_mobile.19aea1ea.png";